export default "__VITE_ASSET__CRytwmfX__"